import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { HHIERows } from '../display-members/table/HHIERows';
import { HHIEButton } from '../utility/HHIEButton';
import Loading from '../utility/Loading';

export default function ViewMembersAddedToday() {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [members, setMembers] =  useState();

    const fetchNewlyAddedMembers = async () => {
        setLoading(true);
        const newMembers = await fetch('api/member/get-newest-members')
        .then(async (response) => {
            try {
                const res = await response.json()
                    .then(json => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        return json.message
                    });
                return res;
            } catch (ex) {
                return console.log(ex);
            }
        })
        .catch((ex) => {
            console.log(ex);
        });
        if (newMembers !== null) {
            setMembers(newMembers);
            setLoading(false);
        }
    };

    const refresh = async () => {
        setMembers(null);
        await fetchNewlyAddedMembers();
    };

    const handleClose = () => {
        setLoading(false);
        setShow(false);
    };

    const handleShow = async () => {
        setShow(true);
        if (!members) {
            await fetchNewlyAddedMembers();
        }
    };

    return (
      <>
        <HHIEButton 
          variant="outline-primary" 
          onClick={handleShow}
          marginl={4}
          title="View Recently Added Members"
        />
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
          centered
        >
          <Modal.Header>
            <Modal.Title>Recently Added Members (Today)</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading &&  <Loading message="Loading please wait. . ."/> }
            {members && <HHIERows members={members} id="new-members-table"/> }
          </Modal.Body>
          <Modal.Footer>
            {members && 
            <HHIEButton 
              variant="primary" 
              onClick={refresh}
              title="Refresh"
            />
            }
            <HHIEButton 
              variant="warning" 
              onClick={handleClose}
              title="Close"
            />
          </Modal.Footer>
        </Modal>
      </>
    );
  }